var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKnowLikesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.44799 1.76494L7.44845 1.76446C7.9741 1.22422 8.66506 0.95414 9.35893 0.95414C10.0529 0.95414 10.744 1.22403 11.2695 1.76406C12.3283 2.85387 12.3277 4.61944 11.2688 5.71153L11.2685 5.71183L6.51815 10.6158L1.75929 5.71878C1.75928 5.71877 1.75928 5.71877 1.75927 5.71876C0.699737 4.62839 0.69977 2.85455 1.75931 1.76407C2.80641 0.6864 4.53231 0.686371 5.57953 1.76409L5.58035 1.76494L5.94644 2.14056L6.51417 2.72308L7.0819 2.14056L7.44799 1.76494Z",
    stroke: "#65A0F1",
    strokeWidth: 1.58553
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowLikesIcon);
export default __webpack_public_path__ + "static/media/know-likes-icon.cbd21a9c8286ac5c7b0abc325154695b.svg";
export { ForwardRef as ReactComponent };